<div class="min-h-screen flex">
  <div class="flex-1 flex flex-col items-center mx-auto my-auto">
    <div class="flex w-full items-center justify-center mb-12">
      <img src="images/logo/logo.png" alt="Logo" width="58" height="58" />
    </div>
    <div class="bg-shikenso-base-white px-14 py-10 rounded-2xl max-w-[480px]">
      <div class="flex flex-col items-center justify-center gap-2 mb-6 px-6">
        <h1 class="text-[28px] font-bold text-black">{{ 'pages.createPassword.title' | translate }}</h1>
        <p class="text-shikenso-gray-700 text-sm text-center">{{ 'pages.createPassword.description' | translate }}</p>
      </div>

      <form [formGroup]="passwordForm" class="custom-form flex flex-col gap-2" (ngSubmit)="onSubmit()">
        <mat-form-field class="w-full">
          <mat-label>{{ 'pages.createPassword.password' | translate }}</mat-label>
          <input matInput [type]="showPassword() ? 'text' : 'password'" formControlName="password" />
          <button
            mat-icon-button
            matSuffix
            type="button"
            class="!bg-transparent mat-big-icon-button"
            (click)="showPassword.set(!showPassword())"
          >
            @if (showPassword()) {
              <app-icon src="/icons/view-off.svg" alt="View off" />
            } @else {
              <app-icon src="/icons/view.svg" alt="View" />
            }
          </button>
          <mat-error [control]="passwordForm.get('password')" />
        </mat-form-field>

        <mat-form-field class="w-full">
          <mat-label>{{ 'pages.createPassword.confirmPassword' | translate }}</mat-label>
          <input matInput [type]="showConfirmPassword() ? 'text' : 'password'" formControlName="confirmPassword" />
          <button
            mat-icon-button
            matSuffix
            type="button"
            class="!bg-transparent mat-big-icon-button"
            (click)="showConfirmPassword.set(!showConfirmPassword())"
          >
            @if (showConfirmPassword()) {
              <app-icon src="/icons/view-off.svg" alt="View off" />
            } @else {
              <app-icon src="/icons/view.svg" alt="View" />
            }
          </button>
          <mat-error [control]="passwordForm.get('confirmPassword')" />
        </mat-form-field>

        <!-- Buttons -->
        <div class="flex items-center justify-center">
          <button mat-flat-button type="submit" class="w-full" [disabled]="loading()">
            @if (loading()) {
              <app-dots-spinner />
            } @else {
              {{ 'pages.createPassword.createPassword' | translate }}
            }
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
